import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { HttpService } from '../../base/http.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { CustomValidators } from '../../base/custom-validator';
import { Router } from '@angular/router';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent implements OnInit {
  @Output() onLoading = new EventEmitter<boolean>();

  public formGroup: FormGroup;
  constructor(private httpService: HttpService, private router: Router, private builder: FormBuilder) {
    this.createFormGroup();
  }

  public createFormGroup() {
    this.formGroup = this.builder.group(
      {
        name: new FormControl('', [Validators.required]),
        kana: new FormControl('', [Validators.required]),
        email: new FormControl('', [Validators.required, Validators.email]),
        content: new FormControl('', [Validators.required])
      },
      { validator: CustomValidators.kana }
    );
  }

  public get isError() {
    return this.formGroup.controls;
  }

  ngOnInit(): void {}

  public onAccept() {
    this.onLoading.emit(true);

    if (this.formGroup.valid) {
      this.httpService.post('contact', this.formGroup.value).subscribe(
        value =>
          this.router.navigate(['/complete'], {
            queryParams: {
              iconSrc: '/assets/img/vector.png',
              title: 'お問い合わせありがとうございました。',
              messege: '内容を確認次第、3営業日以内に担当者よりご連絡いたします。\n\r恐れ入りますが、今しばらくお待ちください。'
            }
          }),
        error => console.log(error),
        () => this.onLoading.emit(false)
      );
    } else {
      this.onLoading.emit(false);
    }
  }
}
